/**
 * A dependency-free signal between the API client and device-session.service:
 * the API client sees a 403 DEVICE_SESSION_TENANT_MISMATCH (a device-bound
 * token sent to another tenant) and asks for a registration in the active
 * tenant. Kept separate so services/api.ts does not import the registration
 * code, which itself depends on the API client.
 */
type Listener = () => void;
const listeners = new Set<Listener>();

export function onDeviceSessionCheckRequested(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function requestDeviceSessionCheck(): void {
  for (const listener of listeners) {
    try {
      listener();
    } catch {
      // never let a listener break the API client's error path
    }
  }
}

export function isDeviceSessionTenantMismatch(status: number | undefined, data: unknown): boolean {
  if (status !== 403 || !data || typeof data !== 'object') return false;
  return (data as { error?: { code?: unknown } }).error?.code === 'DEVICE_SESSION_TENANT_MISMATCH';
}
